import { call, put } from 'redux-saga/effects';
import { api, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { AllowShipPickingActions } from 'store/ducks/pickings';

export function* allowShipPickingRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/picking/allow-shipment/${id}`,
    );

    const { data } = responseBody;
    yield put(AllowShipPickingActions.success(data));
    notify("success", "Carga liberada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(AllowShipPickingActions.failure(errorMessage));
  }
}
